// Convert civil host times to instants. Reject DST gaps instead of silently shifting.
export function hostInstant(day,time,zone){
 const [y,m,d]=day.split('-').map(Number),[h,min]=time.split(':').map(Number);
 const wanted=Date.UTC(y,m-1,d,h,min);let candidate=wanted;
 const format=new Intl.DateTimeFormat('en-GB',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 const civil=instant=>{const p=Object.fromEntries(format.formatToParts(new Date(instant)).map(x=>[x.type,x.value]));return Date.UTC(+p.year,+p.month-1,+p.day,+p.hour,+p.minute,+p.second);};
 for(let i=0;i<4;i++){const delta=wanted-civil(candidate);if(!delta)return new Date(candidate).toISOString();candidate+=delta;}
 throw new Error('Questo orario non esiste nel fuso della sede: controlla il cambio dell’ora.');
}
export function guestWindows(from,to,opens,closes,zone){
 const first=new Date(from+'T12:00:00Z'),last=new Date(to+'T12:00:00Z'),windows=[];
 if(!Number.isFinite(+first)||!Number.isFinite(+last)||first>last)throw new Error('Controlla le date del guest.');
 for(let day=first;day<=last;day.setUTCDate(day.getUTCDate()+1)){
  if(windows.length>=90)throw new Error('Massimo 90 giorni per incarico.');
  const date=day.toISOString().slice(0,10),start=hostInstant(date,opens,zone),end=hostInstant(date,closes,zone);
  if(end<=start)throw new Error('La fine del turno deve seguire l’inizio nello stesso giorno.');
  windows.push({start,end});
 }
 return windows;
}
